module.exports = __webpack_public_path__ + "media/images/btn_main-e199c4b998dec0c4c0b1fb8545721b28.gif";